(function () {
  'use strict';

  class RRGCartDrawer {
    constructor() {
      this.el = null;
      this.body = null;
      this.footer = null;
      this.isOpen = false;
      this._recoController   = null;
      this._recoMode         = 'ai';
      this._recoSeq          = 0;
      this._lastCart         = null;
      this._lastRecoCartKey  = null;
      this._lastRecoProducts = null;
      this._cachedManualProducts = null;
      this._inject();
      this._init();
    }

    _inject() {
      const div = document.createElement('div');
      div.innerHTML = `
        <div id="rrg-cart-drawer" class="rrg-cd" aria-hidden="true" role="dialog" aria-label="Cart">
          <div class="rrg-cd__overlay"></div>
          <div class="rrg-cd__panel">
            <div class="rrg-cd__header">
              <span class="rrg-cd__title">Cart</span>
              <button class="rrg-cd__close" aria-label="Close cart">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
            <div class="rrg-cd__ship-bar" id="rrg-cd-ship-bar"></div>
            <div class="rrg-cd__scroll">
              <div class="rrg-cd__body" id="rrg-cd-body"></div>
            </div>
            <div class="rrg-cd__footer" id="rrg-cd-footer"></div>
          </div>
        </div>
      `;
      document.body.appendChild(div.firstElementChild);

      this.el      = document.getElementById('rrg-cart-drawer');
      this.shipBar = document.getElementById('rrg-cd-ship-bar');
      this.body    = document.getElementById('rrg-cd-body');
      this.footer  = document.getElementById('rrg-cd-footer');
    }

    _init() {
      if (!sessionStorage.getItem('rrg_note_cleared')) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'note='
        });
        sessionStorage.setItem('rrg_note_cleared', '1');
      }

      this.el.addEventListener('click', (e) => {
        if (!e.target.closest('.rrg-cd__panel')) this.close();
      });
      this.el.querySelector('.rrg-cd__close').addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen) this.close(); });

      document.addEventListener('click', (e) => {
        if (e.target.closest('.cart-drawer-container > summary')) {
          e.preventDefault();
          e.stopPropagation();
          this.fetchAndOpen();
        }
      }, true);

      const patchMiniCart = () => {
        const mc = document.querySelector('mini-cart');
        if (!mc) return;
        mc.open           = () => this.fetchAndOpen();
        mc.renderContents = () => {
          document.dispatchEvent(new CustomEvent('rrg:atc:done'));
          return this.isOpen ? this.fetchAndRender() : this.fetchAndOpen();
        };
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', patchMiniCart);
      } else {
        patchMiniCart();
      }
      setTimeout(patchMiniCart, 300);

      document.addEventListener('rrg:cart:added', () => this.fetchAndOpen());

      document.addEventListener('cart:updated', () => {
        if (this.isOpen) this.fetchAndRender();
      });
    }

    open() {
      const oldDetails = document.querySelector('.cart-drawer-container');
      if (oldDetails) {
        oldDetails.removeAttribute('open');
        oldDetails.classList.remove('menu-opening');
      }
      document.body.classList.add('rrg-drawer-open');
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.isOpen = true;
      this._track('cart_drawer_open');
    }

    close() {
      document.body.classList.remove('rrg-drawer-open');
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this.isOpen = false;
    }

    async fetchAndOpen() {
      await this.fetchAndRender();
      if (!this.isOpen) this.open();
    }

    async fetchAndRender() {
      let cart;
      try {
        cart = await fetch('/cart.js').then(r => r.json());
      } catch (_) {
        return;
      }
      this._lastCart = cart;
      this._renderShipBar(cart);
      this._renderBody(cart);
      this._renderFooter(cart);
      this._updateBubble(cart.item_count);
      this._syncUpsellButtons(cart);
      this._loadSubscriptionSelectors(cart);
      this._fetchAndRenderRecommendations(cart);
    }

    _syncUpsellButtons(cart) {
      const cartKeys = new Set((cart.items || []).map(i => i.key));
      document.querySelectorAll('.rrg-upsell-item__add[data-cart-key]').forEach(btn => {
        if (!cartKeys.has(btn.dataset.cartKey)) {
          delete btn.dataset.cartKey;
          btn.textContent = 'Add';
          btn.classList.remove('is-added');
          btn.disabled = false;
        }
      });
    }

    _renderBody(cart) {
      if (cart.item_count === 0) {
        this.body.innerHTML = `
          <div class="rrg-cd__empty">
            <p>Your cart is empty</p>
            <a href="/collections/all" class="rrg-cd__continue">Continue Shopping</a>
          </div>`;
        return;
      }

      this.body.innerHTML = cart.items.map((item) => `
        <div class="rrg-cd__item" data-key="${item.key}" data-unit-price="${item.price}">
          <button class="rrg-cd__remove" data-key="${item.key}" aria-label="Remove ${item.product_title}">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div class="rrg-cd__item-img">
            ${this._imgTag(item)}
          </div>
          <div class="rrg-cd__item-info">
            <a class="rrg-cd__item-title" href="${item.url}">${item.product_title}</a>
            <div class="rrg-cd__item-options">
              ${this._itemOptions(item)}
            </div>
            ${this._renderSubscriptionDropdown(item)}
            <div class="rrg-cd__item-row">
              <div class="rrg-cd__qty">
                <button class="rrg-cd__qty-btn" data-key="${item.key}" data-action="minus" aria-label="Decrease">&#8722;</button>
                <span class="rrg-cd__qty-num">${item.quantity}</span>
                <button class="rrg-cd__qty-btn" data-key="${item.key}" data-action="plus" aria-label="Increase">+</button>
              </div>
              <span class="rrg-cd__item-price">${this._money(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      `).join('');

      this._attachQtyListeners();
      this._attachRemoveListeners();
    }

    _renderFooter(cart) {
      if (cart.item_count === 0) {
        this.footer.innerHTML = '';
        this.footer.hidden = true;
        return;
      }
      this.footer.hidden = false;

      const shippingUrl = '/policies/shipping-policy';

      this.footer.innerHTML = `
        <button class="rrg-cd__note-row" aria-expanded="false" aria-controls="rrg-cd-note">
          <span>Add Note</span>
          <span class="rrg-cd__note-toggle" aria-hidden="true">+</span>
        </button>
        <div class="rrg-cd__note-area" id="rrg-cd-note" hidden>
          <textarea class="rrg-cd__note-input" placeholder="Add a note to your order">${cart.note || ''}</textarea>
          <button class="rrg-cd__note-save">Save</button>
        </div>
        <div class="rrg-cd__divider"></div>
        <a href="${shippingUrl}" class="rrg-cd__shipping-link">Shipping</a>
        <div class="rrg-cd__divider"></div>
        <button class="rrg-cd__checkout" id="rrg-cd-checkout">
          Check Out ${this._money(cart.total_price)} ${cart.currency}
        </button>
      `;

      const noteRow    = this.footer.querySelector('.rrg-cd__note-row');
      const noteToggle = this.footer.querySelector('.rrg-cd__note-toggle');
      const noteArea   = this.footer.querySelector('#rrg-cd-note');
      noteRow.addEventListener('click', () => {
        noteArea.hidden        = !noteArea.hidden;
        noteToggle.textContent = noteArea.hidden ? '+' : '−';
        noteRow.setAttribute('aria-expanded', String(!noteArea.hidden));
      });

      this.footer.querySelector('.rrg-cd__note-save').addEventListener('click', async (e) => {
        const btn  = e.currentTarget;
        const note = this.footer.querySelector('.rrg-cd__note-input').value;
        btn.textContent = 'Saving...';
        btn.disabled    = true;
        try {
          await fetch('/cart/update.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body:    `note=${encodeURIComponent(note)}`
          });
          btn.textContent = 'Saved!';
          setTimeout(() => { btn.textContent = 'Save'; btn.disabled = false; }, 1500);
        } catch (_) {
          btn.textContent = 'Save';
          btn.disabled    = false;
        }
      });

      this.footer.querySelector('#rrg-cd-checkout').addEventListener('click', () => {
        this._track('cart_drawer_checkout', {
          value: cart.total_price / 100,
          currency: cart.currency
        });
        const form   = document.createElement('form');
        form.method  = 'post';
        form.action  = '/cart';
        const input  = document.createElement('input');
        input.type   = 'hidden';
        input.name   = 'checkout';
        input.value  = '';
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
      });
    }

    _attachRemoveListeners() {
      this.body.querySelectorAll('.rrg-cd__remove').forEach(btn => {
        btn.addEventListener('click', () => {
          const key    = btn.dataset.key;
          const itemEl = btn.closest('.rrg-cd__item');
          this._updateItem(itemEl, key, 0, -1);
        });
      });
    }

    _attachQtyListeners() {
      this.body.querySelectorAll('.rrg-cd__qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const key    = btn.dataset.key;
          const itemEl = btn.closest('.rrg-cd__item');
          const numEl  = itemEl.querySelector('.rrg-cd__qty-num');
          const delta  = btn.dataset.action === 'plus' ? 1 : -1;
          const next   = Math.max(0, parseInt(numEl.textContent, 10) + delta);
          this._updateItem(itemEl, key, next, delta);
        });
      });
    }

    async _updateItem(itemEl, key, quantity, delta) {
      const numEl     = itemEl.querySelector('.rrg-cd__qty-num');
      const priceEl   = itemEl.querySelector('.rrg-cd__item-price');
      const unitPrice = parseInt(itemEl.dataset.unitPrice, 10) || 0;

      if (quantity === 0) {
        const h = itemEl.offsetHeight;
        itemEl.style.maxHeight  = h + 'px';
        itemEl.style.overflow   = 'hidden';
        itemEl.style.transition = 'max-height 0.28s ease, opacity 0.28s ease, padding 0.28s ease';
        requestAnimationFrame(() => {
          itemEl.style.opacity       = '0';
          itemEl.style.maxHeight     = '0';
          itemEl.style.paddingTop    = '0';
          itemEl.style.paddingBottom = '0';
        });
        setTimeout(() => itemEl.remove(), 290);

        let cart;
        try {
          cart = await fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity })
          }).then(r => r.json());
        } catch (_) {
          await this.fetchAndRender();
          return;
        }

        if (cart.item_count === 0) {
          this._renderBody(cart);
          this._renderFooter(cart);
        } else {
          this._updateCheckout(cart);
        }
        this._updateBubble(cart.item_count);
        return;
      }

      const animClass = delta > 0 ? 'anim-up' : 'anim-down';
      numEl.classList.remove('anim-up', 'anim-down');
      numEl.textContent = quantity;
      void numEl.offsetWidth;
      numEl.classList.add(animClass);

      const minusBtn = itemEl.querySelector('.rrg-cd__qty-btn[data-action="minus"]');
      if (minusBtn) minusBtn.disabled = quantity <= 0;

      if (priceEl && unitPrice) {
        priceEl.textContent = this._money(unitPrice * quantity);
      }

      let cart;
      try {
        cart = await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        }).then(r => r.json());
      } catch (_) {
        numEl.textContent = quantity - delta;
        return;
      }

      const actual = (cart.items || []).find(i => i.key === key);
      if (actual && priceEl) priceEl.textContent = this._money(actual.final_line_price);

      this._updateCheckout(cart);
      this._updateBubble(cart.item_count);
    }

    _updateCheckout(cart) {
      const btn = this.footer.querySelector('.rrg-cd__checkout');
      if (btn) {
        btn.textContent = `Check Out ${this._money(cart.total_price)} ${cart.currency}`;
      }
      this._renderShipBar(cart);
    }

    _renderShipBar(cart) {
      if (!this.shipBar) return;
      if (cart.item_count === 0) {
        this.shipBar.innerHTML = '';
        return;
      }
      this.shipBar.innerHTML = this._renderFreeShippingBar(cart);
    }

    _freeShippingAmount(currency) {
      const cfg = window.RRGFreeShipping;
      if (!cfg || !cfg.enabled || !cfg.raw) return null;
      const parts = cfg.raw.split(',');
      let amount;
      if (parts.length > 1) {
        for (const part of parts) {
          const [code, amt] = part.split(':');
          if (code && code.toUpperCase() === (currency || '').toUpperCase() && amt) {
            amount = parseFloat(amt) * 100;
            break;
          }
        }
      } else {
        const single = parts[0];
        if (single.includes(':')) {
          amount = parseFloat(single.split(':')[1]) * 100;
        } else {
          amount = parseFloat(single) * 100;
        }
      }
      return Number.isFinite(amount) && amount > 0 ? amount : null;
    }

    _renderFreeShippingBar(cart) {
      const items = cart.items || [];
      const isGlove      = t => { const s = (t || '').toLowerCase(); return s.includes('glove') && !s.includes('case'); };
      const hasGloves    = items.some(i => isGlove(i.product_type));
      const hasNonGloves = items.some(i => !isGlove(i.product_type));

      if (hasGloves && !hasNonGloves) {
        return `<div class="rrg-cd__free-ship rrg-cd__free-ship--done">
          <span class="rrg-cd__free-ship-text">Your gloves ship free!</span>
          <span class="rrg-cd__free-ship-bar"><span class="rrg-cd__free-ship-fill" style="width:100%"></span></span>
        </div>`;
      }

      const threshold = this._freeShippingAmount(cart.currency);
      if (!threshold) return '';
      const total = cart.total_price;
      if (!Number.isFinite(total)) return '';
      if (total >= threshold) {
        return `<div class="rrg-cd__free-ship rrg-cd__free-ship--done">
          <span class="rrg-cd__free-ship-text">You've unlocked Free Shipping!</span>
          <span class="rrg-cd__free-ship-bar"><span class="rrg-cd__free-ship-fill" style="width:100%"></span></span>
        </div>`;
      }
      const remaining = threshold - total;
      const percent = Math.min(100, Math.round((total / threshold) * 100));
      return `<div class="rrg-cd__free-ship">
        <span class="rrg-cd__free-ship-text">Spend <strong>${this._money(remaining)}</strong> more for Free Shipping</span>
        <span class="rrg-cd__free-ship-bar"><span class="rrg-cd__free-ship-fill" style="width:${percent}%"></span></span>
      </div>`;
    }

    _renderSubscriptionDropdown(item) {
      if (item.selling_plan_allocation) {
        const planId   = item.selling_plan_allocation.selling_plan.id;
        const planName = item.selling_plan_allocation.selling_plan.name;
        return `
          <div class="rrg-cd__sub-wrap" data-sub-key="${item.key}">
            <select class="rrg-cd__sub-select rrg-cd__sub-select--loading"
              data-key="${item.key}"
              data-variant-id="${item.variant_id}"
              data-quantity="${item.quantity}"
              disabled>
              <option value="">One-time purchase</option>
              <option value="${planId}" selected>${planName}</option>
            </select>
            <svg class="rrg-cd__sub-caret" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </div>`;
      }
      return `<div class="rrg-cd__sub-wrap" data-sub-key="${item.key}"></div>`;
    }

    async _loadSubscriptionSelectors(cart) {
      const allItems = cart.items || [];
      if (!allItems.length) return;

      const handles = [...new Set(allItems.map(i => i.handle))];
      const productMap = {};

      await Promise.all(handles.map(async (handle) => {
        try {
          productMap[handle] = await fetch(`/products/${handle}.js`).then(r => r.json());
        } catch (_) {}
      }));

      allItems.forEach((item) => {
        const product = productMap[item.handle];
        if (!product) return;

        const groups = product.selling_plan_groups || [];
        const wrapEl = this.body.querySelector(`.rrg-cd__sub-wrap[data-sub-key="${item.key}"]`);
        if (!wrapEl) return;

        if (!groups.length) return;

        const currentPlanId = item.selling_plan_allocation?.selling_plan?.id || null;

        let options = `<option value="" ${!currentPlanId ? 'selected' : ''}>One-time purchase</option>`;
        groups.forEach((group) => {
          (group.selling_plans || []).forEach((plan) => {
            const sel = plan.id === currentPlanId ? 'selected' : '';
            options += `<option value="${plan.id}" ${sel}>${this._planLabel(plan)}</option>`;
          });
        });

        wrapEl.innerHTML = `
          <select class="rrg-cd__sub-select"
            data-key="${item.key}"
            data-variant-id="${item.variant_id}"
            data-quantity="${item.quantity}">
            ${options}
          </select>
          <svg class="rrg-cd__sub-caret" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>`;

        const selectEl = wrapEl.querySelector('.rrg-cd__sub-select');
        selectEl.addEventListener('change', (e) => {
          const newPlanId = e.target.value ? parseInt(e.target.value, 10) : null;
          if (newPlanId === currentPlanId) return;
          this._changeSubscriptionPlan(
            item.key,
            item.variant_id,
            parseInt(selectEl.dataset.quantity, 10) || 1,
            newPlanId
          );
        });
      });
    }

    async _changeSubscriptionPlan(key, variantId, quantity, newPlanId) {
      const selectEl = this.body.querySelector(`.rrg-cd__sub-select[data-key="${key}"]`);
      if (selectEl) selectEl.disabled = true;

      try {
        await fetch('/cart/change.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: key, quantity: 0 })
        });

        const payload = { id: variantId, quantity };
        if (newPlanId) payload.selling_plan = newPlanId;

        await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(payload)
        });
      } catch (_) {}

      await this.fetchAndRender();
    }

    async _fetchManualRecos() {
      if (this._cachedManualProducts !== null) return this._cachedManualProducts;
      let handles = [];
      try {
        const el = document.getElementById('rrg-cart-recos-data');
        if (el) handles = JSON.parse(el.textContent) || [];
      } catch (e) {}
      handles = handles.filter(h => typeof h === 'string' && h.length > 0);
      if (!handles.length) { this._cachedManualProducts = []; return []; }
      const results = await Promise.all(
        handles.map(h => fetch(`/products/${h}.js`).then(r => r.json()).catch(() => null))
      );
      this._cachedManualProducts = results.filter(Boolean);
      return this._cachedManualProducts;
    }

    _getManualPool(cartIds) {
      return this._fetchManualRecos().then(all => all.filter(p => !cartIds.has(p.id)));
    }

    async _fetchAndRenderRecommendations(cart) {
      const seq       = ++this._recoSeq;
      const cartItems = cart.items || [];
      const cartEmpty = cartItems.length === 0;
      const cartIds   = new Set(cartItems.map(i => i.product_id));
      const cartKey   = cartItems.map(i => i.product_id).sort().join(',');

      if (this._lastRecoCartKey !== null && cartKey !== this._lastRecoCartKey) this._recoMode = 'ai';

      let section = this.body.querySelector('.rrg-cd__recos');
      if (!section) {
        section = document.createElement('div');
        section.className = 'rrg-cd__recos';
        this.body.appendChild(section);
      }

      const manualPool = await this._getManualPool(cartIds);
      if (seq !== this._recoSeq) return;

      const hasManual = manualPool.length > 0;
      const seedId    = cartEmpty
        ? (hasManual ? manualPool[0].id : null)
        : cartItems[0].product_id;

      if (!seedId && !hasManual) { section.remove(); return; }

      if (this._recoMode === 'manual' && hasManual) {
        section.innerHTML = this._recoHeader('manual', !!seedId) + manualPool.map(p => this._renderRecoCard(p)).join('');
        this._attachRecoListeners(section, manualPool);
        this._attachRecoToggle(section, !!seedId);
        return;
      }

      if (!seedId) {
        section.innerHTML = this._recoHeader('manual', false) + manualPool.map(p => this._renderRecoCard(p)).join('');
        this._attachRecoListeners(section, manualPool);
        return;
      }

      if (cartKey === this._lastRecoCartKey && this._lastRecoProducts) {
        const products = this._lastRecoProducts.filter(p => !cartIds.has(p.id));
        section.innerHTML = this._recoHeader('ai', hasManual) + products.map(p => this._renderRecoCard(p)).join('');
        this._attachRecoListeners(section, products);
        this._attachRecoToggle(section, hasManual);
        return;
      }

      if (!section.querySelector('.rrg-cd__reco-card')) {
        section.innerHTML = this._recoHeader('ai', hasManual) + `<div class="rrg-cd__recos-skeleton"></div>`;
        this._attachRecoToggle(section, hasManual);
      }

      if (this._recoController) this._recoController.abort();
      this._recoController = new AbortController();
      const { signal } = this._recoController;

      try {
        const data = await fetch(
          `/recommendations/products.json?product_id=${seedId}&limit=5&intent=related`,
          { signal }
        ).then(r => r.json());
        if (seq !== this._recoSeq) return;

        const products = (data.products || []).filter(p => !cartIds.has(p.id)).slice(0, 4);
        this._lastRecoCartKey  = cartKey;
        this._lastRecoProducts = products;

        if (!products.length) {
          if (hasManual) {
            this._recoMode = 'manual';
            section.innerHTML = this._recoHeader('manual', false) + manualPool.map(p => this._renderRecoCard(p)).join('');
            this._attachRecoListeners(section, manualPool);
            this._attachRecoToggle(section, false);
          } else {
            section.remove();
          }
          return;
        }

        section.innerHTML = this._recoHeader('ai', hasManual) + products.map(p => this._renderRecoCard(p)).join('');
        this._attachRecoListeners(section, products);
        this._attachRecoToggle(section, hasManual);
      } catch (err) {
        if (err.name !== 'AbortError' && seq === this._recoSeq) {
          if (hasManual) {
            this._recoMode = 'manual';
            section.innerHTML = this._recoHeader('manual', false) + manualPool.map(p => this._renderRecoCard(p)).join('');
            this._attachRecoListeners(section, manualPool);
            this._attachRecoToggle(section, false);
          } else {
            section.remove();
          }
        }
      }
    }

    _recoHeader(currentMode, hasManual) {
      if (!hasManual) {
        return `<div class="rrg-cd__recos-header"><p class="rrg-cd__recos-title">You may also like</p></div>`;
      }
      return `<div class="rrg-cd__recos-header">
        <div class="rrg-cd__recos-tabs">
          <button class="rrg-cd__recos-tab${currentMode === 'ai' ? ' active' : ''}" data-mode="ai">You may also like</button>
          <button class="rrg-cd__recos-tab${currentMode === 'manual' ? ' active' : ''}" data-mode="manual">Recommended</button>
        </div>
      </div>`;
    }

    _attachRecoToggle(section, canToggle) {
      if (!canToggle) return;
      section.querySelectorAll('.rrg-cd__recos-tab').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const mode = btn.dataset.mode;
          if (mode === this._recoMode) return;
          this._track('cart_drawer_reco_tab_switch', { tab: mode });
          this._recoMode = mode;
          this._fetchAndRenderRecommendations(this._lastCart);
        });
      });
    }

    _renderRecoCard(product) {
      const availableVariants = product.variants.filter(v => v.available);
      const firstVariant = availableVariants[0] || product.variants[0];
      const isSoldOut   = !firstVariant || !firstVariant.available;

      const rawImg = product.image || product.featured_image;
      const imgSrc = rawImg
        ? (rawImg.includes('width=') ? rawImg : `${rawImg}?width=160`)
        : null;
      const img = imgSrc
        ? `<img src="${imgSrc}" alt="${this._esc(product.title)}" loading="lazy">`
        : `<div class="rrg-cd__reco-img-placeholder"></div>`;

      const priceHtml = this._recoPrice(firstVariant);
      const options   = this._getProductOptions(product);

      const actionHtml = isSoldOut
        ? `<button class="rrg-cd__reco-add" disabled>Sold Out</button>`
        : options.length > 0
          ? `<div class="rrg-cd__reco-selects">
              ${options.map((opt, i) => `
                <div class="rrg-cd__reco-sel-wrap">
                  <select class="rrg-cd__reco-sel" data-opt-idx="${i}" data-product-id="${product.id}">
                    ${opt.values.map(val => `<option value="${val}"${firstVariant && firstVariant[`option${i + 1}`] === val ? ' selected' : ''}>${this._esc(val)}</option>`).join('')}
                  </select>
                  <svg class="rrg-cd__sub-caret" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                </div>`).join('')}
             </div>
             <button class="rrg-cd__reco-add" data-variant-id="${firstVariant ? firstVariant.id : ''}">Add</button>`
          : `<button class="rrg-cd__reco-add" data-variant-id="${firstVariant.id}">Add</button>`;

      return `
        <div class="rrg-cd__reco-card" data-product-id="${product.id}">
          <a class="rrg-cd__reco-img" href="${product.url}">${img}</a>
          <div class="rrg-cd__reco-info">
            <a class="rrg-cd__reco-title" href="${product.url}">${this._esc(product.title)}</a>
            <div class="rrg-cd__reco-price">${priceHtml}</div>
            ${actionHtml}
          </div>
        </div>`;
    }

    _attachRecoListeners(container, products) {
      const productMap = {};
      (products || []).forEach(p => { productMap[p.id] = p; });

      container.querySelectorAll('.rrg-cd__reco-sel').forEach(sel => {
        sel.addEventListener('change', (e) => {
          e.stopPropagation();
          const product = productMap[parseInt(sel.dataset.productId, 10)];
          if (!product) return;
          const card    = sel.closest('.rrg-cd__reco-card');
          if (!card) return;
          const allSels    = [...card.querySelectorAll('.rrg-cd__reco-sel')];
          const changedIdx = parseInt(sel.dataset.optIdx, 10);

          const selections = {};
          allSels.forEach(s => { selections[parseInt(s.dataset.optIdx, 10)] = s.value; });

          allSels.forEach(s => {
            const optIdx = parseInt(s.dataset.optIdx, 10);
            if (optIdx <= changedIdx) return;
            const upstream = Object.fromEntries(
              Object.entries(selections).filter(([k]) => parseInt(k) < optIdx)
            );
            [...s.options].forEach(opt => {
              opt.disabled = !this._isOptionAvailable(product, optIdx, opt.value, upstream);
            });
            if (s.options[s.selectedIndex]?.disabled) {
              const first = [...s.options].find(o => !o.disabled);
              if (first) { s.value = first.value; selections[optIdx] = first.value; }
            }
          });

          const variant = this._findVariantBySelections(product, selections);
          const addBtn  = card.querySelector('.rrg-cd__reco-add');
          if (addBtn) {
            addBtn.dataset.variantId = variant ? variant.id : '';
            addBtn.disabled = !variant?.available;
          }
        });
      });

      container.querySelectorAll('.rrg-cd__reco-img, .rrg-cd__reco-title').forEach(el => {
        el.addEventListener('click', () => {
          const card = el.closest('.rrg-cd__reco-card');
          const product = productMap[parseInt(card?.dataset.productId, 10)];
          if (product) {
            this._track('cart_drawer_reco_click', {
              product_id: product.id,
              product_title: product.title,
              source: this._recoMode
            });
          }
        });
      });

      container.querySelectorAll('.rrg-cd__reco-add').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.stopPropagation();
          const variantId = btn.dataset.variantId;
          if (!variantId || btn.disabled) return;
          btn.disabled    = true;
          btn.textContent = 'Adding...';
          try {
            await fetch('/cart/add.js', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
            });
            const card = btn.closest('.rrg-cd__reco-card');
            const product = productMap[parseInt(card?.dataset.productId, 10)];
            if (product) {
              this._track('cart_drawer_reco_add', {
                product_id: product.id,
                product_title: product.title,
                variant_id: parseInt(variantId, 10),
                source: this._recoMode
              });
            }
            btn.textContent = 'Added!';
            setTimeout(() => this.fetchAndRender(), 700);
          } catch (_) {
            btn.textContent = 'Add';
            btn.disabled    = false;
          }
        });
      });
    }

    _getProductOptions(product) {
      const raw = product.options || [];
      const names = raw.map(o => (typeof o === 'string' ? o : (o && o.name) || ''));
      if (names.length === 1 && names[0] === 'Title') return [];

      const valuesByIdx = names.map(() => []);
      (product.variants || []).forEach(v => {
        names.forEach((_, i) => {
          const val = v[`option${i + 1}`];
          if (val && !valuesByIdx[i].includes(val)) valuesByIdx[i].push(val);
        });
      });

      if (valuesByIdx.every(vals => vals.length <= 1)) return [];

      return names.map((name, i) => ({ name, values: valuesByIdx[i] }));
    }

    _isOptionAvailable(product, optIdx, value, selections) {
      return (product.variants || []).some(v => {
        if (!v.available) return false;
        if (v[`option${optIdx + 1}`] !== value) return false;
        return Object.entries(selections).every(([idx, sel]) => {
          if (parseInt(idx) === optIdx) return true;
          return v[`option${parseInt(idx) + 1}`] === sel;
        });
      });
    }

    _findVariantBySelections(product, selections) {
      const opts = product.options || [];
      return (product.variants || []).find(v =>
        opts.every((_, i) => v[`option${i + 1}`] === selections[i])
      ) || null;
    }

    _itemOptions(item) {
      const opts = item.options_with_values || [];
      return (opts.length === 1 && opts[0].name === 'Title')
        ? ''
        : opts.map(o => `<span class="rrg-cd__option">${o.name}: ${o.value}</span>`).join('');
    }

    _imgTag(item) {
      if (!item.featured_image?.url) return '';
      const base = item.featured_image.url;
      const sep  = base.includes('?') ? '&' : '?';
      return `<img src="${base}${sep}width=320" alt="${item.product_title}" loading="lazy">`;
    }

    _planLabel(plan) {
      const adj = (plan.price_adjustments || [])[0];
      if (!adj || !adj.value) return plan.name;
      if (adj.value_type === 'percentage') {
        return `${plan.name} — ${adj.value}% off`;
      }
      if (adj.value_type === 'fixed_amount') {
        return `${plan.name} — ${this._money(adj.value)} off`;
      }
      return plan.name;
    }

    _recoPrice(variant) {
      if (!variant) return '';
      const price   = this._money(variant.price);
      const compare = variant.compare_at_price && variant.compare_at_price > variant.price
        ? `<s class="rrg-cd__reco-compare">${this._money(variant.compare_at_price)}</s>`
        : '';
      return `<span>${price}</span>${compare}`;
    }

    _money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    _esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    _track(eventName, params) {
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', eventName, params || {});
    }

    _updateBubble(count) {
      ['#cart-icon-bubble', '#mobile-cart-icon-bubble'].forEach(parentSel => {
        const parent = document.querySelector(parentSel);
        if (!parent) return;

        let bubble = parent.querySelector('.cart-count-bubble');

        if (count === 0) {
          if (bubble) bubble.remove();
          return;
        }

        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} item${count !== 1 ? 's' : ''}</span>`;
          parent.appendChild(bubble);
          return;
        }

        const ariaEl = bubble.querySelector('span[aria-hidden]');
        const visEl  = bubble.querySelector('span.visually-hidden');
        if (ariaEl) ariaEl.textContent = count;
        if (visEl)  visEl.textContent  = `${count} item${count !== 1 ? 's' : ''}`;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { window.RRGCartDrawerInstance = new RRGCartDrawer(); });
  } else {
    window.RRGCartDrawerInstance = new RRGCartDrawer();
  }
})();
